import type { Transaction } from '@api/hooks/types/getTransactions';
import { formatNumberAmount } from '@utils/utils';
import { useTranslation } from 'react-i18next';

import { LabeledField } from './LabeledField';

export const SignPaymentCellMobile = ({
	beneficiary,
	document_number,
	execution_date,
	amount,
	currency,
}: Transaction) => {
	const { t } = useTranslation('', { keyPrefix: 'signPayments.table' });

	return (
		<div className="flex flex-col gap-space-16">
			<LabeledField label={t('beneficiary')}>
				<div className="flex flex-col">
					<span className="text-sm-bold text-neutral-950">
						{beneficiary.account_number}
					</span>
					<span className="text-sm-medium text-neutral-600">{beneficiary.name}</span>
				</div>
			</LabeledField>

			<LabeledField label={t('docNo')}>
				<span className="text-sm-bold text-neutral-950">{document_number}</span>
			</LabeledField>

			<LabeledField label={t('date')}>
				<span className="text-sm-bold text-neutral-950">{execution_date}</span>
			</LabeledField>

			<LabeledField label={t('amount')}>
				<span className="text-sm-bold text-neutral-950">
					{formatNumberAmount(amount.toFixed(2))} {currency}
				</span>
			</LabeledField>
		</div>
	);
};
